import TargetGoalCard from './TargetGoalCard';

export default TargetGoalCard;
